import React, { Fragment } from 'react';
import { Intro, Voiceover, FlipCard } from 'abbot-core';
import img1 from '../../assets/images/U1-T2-2-4a.svg';
import img2 from '../../assets/images/U1-T2-2-4b.svg';
import img3 from '../../assets/images/U1-T2-2-4c.svg';
import voAudio from '../../assets/vo/U1-T2-2-4.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript: (
    <p>
      You’ve seen how making nutritious food choices can help your health. Now
      let’s learn about what can happen if you don’t make the most nutritious
      food choices possible.
    </p>
  )
};

const data = {
  cards: [
    {
      title: 'Type 2 Diabetes',
      frontOfCard: {
        header: 'Type 2 Diabetes',
        // text: (
        //   <span>
        //   </span>
        // ),
        image: img1,
        imageText: 'Type 2 Diabetes'
      },
      backOfCard: {
        text:
          'Type 2 diabetes is a condition where you have too much glucose (sugars) in your blood. This can lead to serious illness over time. Making food choices that have less sugar helps your body better regulate the total amount of glucose in your blood.',
        image: img1,
        imageText: 'Type 2 Diabetes'
      }
    },
    {
      title: 'High blood pressure',
      frontOfCard: {
        header: 'High Blood Pressure',
        // text: '',
        image: img2,
        imageText: 'High blood pressure'
      },
      backOfCard: {
        text:
          'High blood pressure happens when the diameter of arteries that carry blood gets smaller and become' +
          ' less flexible. The blood pushes on the artery walls increasing the pressure to a point of danger. Heart' +
          ' attacks and strokes are common results. Choosing foods with less saturated fat can help prevent the build-up of plaque in the arteries, reducing the risk of high blood pressure.',
        image: img2,
        imageText: 'High blood pressure'
      }
    },
    {
      title: 'Heart Disease',
      frontOfCard: {
        header: 'Heart Disease',
        image: img3,
        imageText: 'Heart Disease'
      },
      backOfCard: {
        // header: '',
        text:
          'Certain types of fats, such as saturated fats, build up in the body’s arteries. In the heart, this is called heart disease and can result in heart attacks. Choosing foods with less fat, especially saturated fat, reduces fats in the blood and fat build-up in the arteries.',
        image: img3,
        imageText: 'Heart Disease'
      }
    }
  ]
};

export default {
  title: 'Risks of Poor Food Choices',
  path: '/learn/risks-of-poor-food-choices',
  content: (
    <Fragment>
      <Voiceover {...vo} />

      <Intro
        title="Risks of Poor Food Choices"
        lead="What are some possible risks of not making nutritious food choices?"
        direction="Select each card to learn more about three non-communicable diseases that could potentially result from not making the most nutritious food choices possible."
      />

      <FlipCard data={data} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/learn/RisksofPoorFoodChoices.js